var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpArrowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99865 3.01836L15.8021 9.63282C16.3063 10.1224 17.1195 10.1224 17.6237 9.63282C17.8645 9.39955 18 9.08136 18 8.74949C18 8.41761 17.8645 8.09942 17.6237 7.86615L9.91079 0.368341C9.40715 -0.122782 8.59285 -0.122782 8.08922 0.368341L0.376337 7.86583C0.135478 8.09942 1.38337e-07 8.41761 1.09324e-07 8.74948C8.03102e-08 9.08136 0.135478 9.39955 0.376337 9.63313C0.880607 10.1224 1.69379 10.1224 2.19791 9.63251L8.99865 3.01836Z",
    fill: "#232323"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99865 3.01836L15.8021 9.63282C16.3063 10.1224 17.1195 10.1224 17.6237 9.63282C17.8645 9.39955 18 9.08136 18 8.74949C18 8.41761 17.8645 8.09942 17.6237 7.86615L9.91079 0.368341C9.40715 -0.122782 8.59285 -0.122782 8.08922 0.368341L0.376337 7.86583C0.135478 8.09942 1.38337e-07 8.41761 1.09324e-07 8.74948C8.03102e-08 9.08136 0.135478 9.39955 0.376337 9.63313C0.880607 10.1224 1.69379 10.1224 2.19791 9.63251L8.99865 3.01836Z",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowIcon);
export default __webpack_public_path__ + "static/media/up-arrow-icon.09b0417382146fe26a3e411705e5f63e.svg";
export { ForwardRef as ReactComponent };